import styled from 'styled-components';

const Container = styled.header`
  width: 100%;
  padding: 13px 15px;

  display: flex;
  align-items: center;

  background-color: white;

  @media screen and (max-height: 750px) {
    padding: 10px 10px;
  }

  @media screen and (max-height: 710px) {
    padding: 6px 6px;
  }
`;

export default Container;